import React from "react";
import Team from "./Team";
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle,
} from "chart.js";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Dropdown from "react-bootstrap/Dropdown";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Pie } from "react-chartjs-2";
import { PolarArea } from "react-chartjs-2";
import {
  usersReference,
  updateUser,
  picksReference,
  getId,
  getWeek,
  leagueId,
  tbMessage,
  sleep,
} from "./App";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import { getWinnersArr } from "./StatsContainer";
import { ThemeConsumer } from "styled-components";

export const analyzePRWeek = (weekData, nameIdArr) => {
  let avgs = [];
  let who = [];

  //iterate through the rankings of the week
  for (let i = 0; i < weekData.length; i++) {
    let currNames = weekData[i].Rankings.map((id) => {
      for (let j = 0; j < nameIdArr.length; j++) {
        if (id === nameIdArr[j][0]) {
          return nameIdArr[j][1];
        }
      }
    });

    who.push(weekData[i].Tid);

    //iterate through the current set of rankings
    for (let j = 0; j < weekData[i].Rankings.length; j++) {
      //if it's the first set of rankings
      if (i == 0) {
        avgs.push([weekData[i].Rankings[j], j + 1, currNames[j]]);
      } else {
        let found = false;
        for (let h = 0; h < avgs.length; h++) {
          if (avgs[h][0] === weekData[i].Rankings[j]) {
            found = true;
            avgs[h] = [
              weekData[i].Rankings[j],
              ((avgs[h][1] + j + 1) * 1.0) / 2,
              currNames[j],
            ];
          }
        }
        if (!found) {
          avgs.push([weekData[i].Rankings[j], j + 1, currNames[j]]);
        }
      }
    }
  }

  who = who.map((t) => {
    for (let i = 0; i < nameIdArr.length; i++) {
      if (nameIdArr[i][0] === t) {
        return nameIdArr[i][1];
      }
    }
  });
  return avgs.sort((a, b) => a[1] - b[1]);
};

Chart.register(RadialLinearScale, ArcElement, Tooltip, Legend);

class StatsWeek extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datasets: [],
      tbGraph: [],
      loadCount: 0,
      selectedWeek: this.props.currWeek,
      prevRows: 0,
      prevRows1: 0,
      ppm: [],
      whoRankedThisWeek: [],
      deletingTables: false,
    };
  }

  componentDidMount() {
    if (this.state.datasets.length == 0) {
      this.createDataSets(this.state.selectedWeek);
    }
    if (this.state.tbGraph.length == 0) {
      this.createTBPlot(this.state.selectedWeek);
    }
    if (this.state.loadCount == 0) {
      this.setTable(this.state.selectedWeek);
      this.getRankingData(this.state.selectedWeek);
      this.setState({ loadCount: this.state.loadCount++ });
    }
  }

  analyzePRWeek = (weekData, nameIdArr) => {
    // let nameIdArr = [...nIA];
    let avgs = [];
    let who = [];

    //iterate through the rankings of the week
    for (let i = 0; i < weekData.length; i++) {
      let currNames = weekData[i].Rankings.map((id) => {
        for (let j = 0; j < nameIdArr.length; j++) {
          if (id === nameIdArr[j][0]) {
            return nameIdArr[j][1];
          }
        }
      });

      who.push(weekData[i].Tid);

      //iterate through the current set of rankings
      for (let j = 0; j < weekData[i].Rankings.length; j++) {
        //if it's the first set of rankings
        if (i == 0) {
          avgs.push([weekData[i].Rankings[j], j + 1, currNames[j]]);
        } else {
          let found = false;
          for (let h = 0; h < avgs.length; h++) {
            if (avgs[h][0] === weekData[i].Rankings[j]) {
              found = true;
              avgs[h] = [
                weekData[i].Rankings[j],
                ((avgs[h][1] + j + 1) * 1.0) / 2,
                currNames[j],
              ];
            }
          }
          if (!found) {
            avgs.push([weekData[i].Rankings[j], j + 1, currNames[j]]);
          }
        }
      }
    }

    who = who.map((t) => {
      for (let i = 0; i < nameIdArr.length; i++) {
        if (nameIdArr[i][0] === t) {
          return nameIdArr[i][1];
        }
      }
    });

    this.setState({ whoRankedThisWeek: who });
    return avgs.sort((a, b) => a[1] - b[1]);
  };

  getRankingData = async (week) => {
    let winnersArr = await getWinnersArr();
    let weekData = this.props.rankingData.filter((r) => r.Week == week);
    let lastWeekData = this.props.rankingData.filter((r) => r.Week == week - 1);
    let lwSortedRanks = [];
    if (week - 1 > 0) {
      lwSortedRanks = await this.analyzePRWeek(
        lastWeekData,
        this.props.nameIdArr
      );
    }

    let sortedRanks = await this.analyzePRWeek(weekData, this.props.nameIdArr);

    //get real records
    let records = this.props.nameIdArr.map((team) => {
      let wins = 0;
      for (let i = 1; i < this.state.selectedWeek; i++) {
        if (winnersArr[i].data.picks.includes(team[0])) {
          wins++;
        }
      }
      // let winPercentage = Math.round(((wins * 1.0) / (week - 1)) * 100);
      return [wins, this.state.selectedWeek - 1 - wins, team[0], team[1]];
    });

    let sr = sortedRanks.map((rank) => {
      for (let i = 0; i < records.length; i++) {
        if (records[i][2] === rank[0]) {
          return [...rank, records[i][0], records[i][1]];
          break;
        }
      }
    });

    sr = sr.map((rank, index) => {
      if (week - 1 > 0 && lwSortedRanks.length > 0) {
        for (let i = 0; i < lwSortedRanks.length; i++) {
          if (lwSortedRanks[i][0] === rank[0]) {
            let difference = i - index;
            let msg = "";
            if (difference < 0) {
              msg = "▼" + Math.abs(difference);
            } else if (difference > 0) {
              msg = "▲" + difference;
            } else {
              msg = "≡";
            }
            return [...rank, i + 1, msg];
          }
        }
      } else {
        return [...rank, 0, "≡"];
      }
    });
    this.createRankingTable(sr);
  };

  createRankingTable = async (ranks) => {
    var table = document.getElementById("prTable");
    for (let i = -1; i < ranks.length; i++) {
      var row = table.insertRow();
      if (i == -1) {
        var cell1 = row.insertCell();
        var cell2 = row.insertCell();
        var cell3 = row.insertCell();
        var cell4 = row.insertCell();
        cell1.innerHTML = "Rank";
        cell2.innerHTML = "Name";
        cell3.innerHTML = "Record";
        cell4.innerHTML = "Last Week";
        row.style.fontWeight = "bolder";
      } else {
        let r = "" + ranks[i][3] + "-" + ranks[i][4];
        let rowContent = [
          i + 1,
          ranks[i][2],
          r,
          ranks[i][5] + " (" + ranks[i][6] + ")",
        ];
        for (let j = 0; j < rowContent.length; j++) {
          var cell1 = row.insertCell();
          if (j == rowContent.length - 1) {
            if (rowContent[j].includes("▼")) {
              // let insert = rowContent[j][0] + " (" + <span>▼</span> + rowContent[j][4] + ")"
              // cell1.innerHTML = rowContent[j].Replace("▼", cell1.innerHTML.format("<span>fsdf</span>", "▼"));;
              cell1.innerHTML = rowContent[j];
              cell1.style.color = "red";
            } else if (rowContent[j].includes("▲")) {
              cell1.innerHTML = rowContent[j];
              cell1.style.color = "green";
            } else {
              cell1.innerHTML = rowContent[j];
            }
          } else {
            cell1.innerHTML = rowContent[j];
          }
        }
      }
    }

    if (this.state.prevRows1 > 0) {
      this.tableCleanup(this.state.prevRows1, table);
    }

    this.setState({ prevRows1: ranks.length + 1 });
  };

  createDataSets = async (week) => {
    let winnersArr = await getWinnersArr();

    let picksPerMatchup = [];
    let sets = [];

    if (this.state.datasets.length == 0) {
      await sleep(500);
    }

    //iterate through the matchups of this week
    for (
      let i = 0;
      i < this.props.matchups[this.state.selectedWeek - 1].length;
      i++
    ) {
      let t1 = 0;
      let t2 = 0;

      //this graph will represent the picks for the following matchup
      let currMatch = [
        this.props.matchups[this.state.selectedWeek - 1][i][0][0],
        this.props.matchups[this.state.selectedWeek - 1][i][1][0],
      ];

      //iterate through the picks of the current week
      for (let j = 0; j < this.props.picksByWeek[week].length; j++) {
        //if the current user picked the first team
        if (this.props.picksByWeek[week][j].Ids.includes(currMatch[0])) {
          t1++;
        } else {
          t2++;
        }
      }

      let tmp = [];
      tmp.push(t1);
      tmp.push(t2);
      let currPie;

      picksPerMatchup.push(tmp);

      if (week < (await getWeek())) {
        if (winnersArr[week].data.picks.includes(currMatch[0])) {
          currPie = {
            // labels: [currMatch[0], currMatch[1]],
            // labels: [...currMatch],
            datasets: [
              {
                label: "# of Picks Recieved",
                data: [t1, t2],
                backgroundColor: [
                  "rgba(255, 0, 0, .8)",
                  "rgba(37, 65, 178, 0.3)",
                ],
                borderColor: ["rgba(255, 0, 0, 1)", "rgba(37, 65, 178, 1)"],
                borderWidth: 3,
              },
            ],
          };
        } else if (winnersArr[week].data.picks.includes(currMatch[1])) {
          currPie = {
            // labels: [currMatch[0], currMatch[1]],
            // labels: [...currMatch],
            datasets: [
              {
                label: "# of Picks Recieved",
                data: [t1, t2],
                backgroundColor: [
                  "rgba(255, 0, 0, 0.3)",
                  "rgba(37, 65, 178, .8)",
                ],
                borderColor: ["rgba(255, 0, 0, 1)", "rgba(37, 65, 178, 1)"],
                borderWidth: 3,
              },
            ],
          };
        }
      } else {
        currPie = {
          // labels: [currMatch[0], currMatch[1]],
          // labels: [...currMatch],
          datasets: [
            {
              label: "# of Picks Recieved",
              data: [t1, t2],
              backgroundColor: [
                "rgba(255, 0, 0, 0.3)",
                "rgba(37, 65, 178, 0.3)",
              ],
              borderColor: ["rgba(255, 0, 0, 1)", "rgba(37, 65, 178, 1)"],
              borderWidth: 3,
            },
          ],
        };
      }

      sets.push(currPie);
    }

    this.setState({ datasets: sets, ppm: picksPerMatchup });
  };

  checkData = (data) => {
    if (data) {
      return <Pie data={data} responsive="true" />;
    } else {
    }
  };

  createTBPlot = (week) => {
    let tbs = [];
    let tbIds = [];
    let tbNames = [];

    console.log('week: ', week);
    console.log('this.props.picksByWeek: ', this.props.picksByWeek);

    week = Math.min(week, 16);
    //iterate through this week's picks
    for (let i = 0; i < this.props.picksByWeek[week].length; i++) {
      tbs.push(this.props.picksByWeek[week][i].TieBreaker);
      tbIds.push(this.props.picksByWeek[week][i].Tid);
    }

    for (let i = 0; i < tbIds.length; i++) {
      for (let j = 0; j < this.props.nameIdArr.length; j++) {
        if (tbIds[i] === this.props.nameIdArr[j][0]) {
          tbNames.push(this.props.nameIdArr[j][1]);
        }
      }
    }

    let currPolar = {
      // labels: [currMatch[0], currMatch[1]],
      labels: [...tbNames],
      datasets: [
        {
          label: tbMessage[week],
          data: [...tbs],
          backgroundColor: [
            "rgba(255,0,0,0.3)",
            "rgba(255,255,0,0.3)",
            "rgba(0,234,255,0.3)",
            "rgba(170,0,255,0.3)",
            "rgba(255,127,0,0.3)",
            "rgba(191,255,0,0.3)",
            "rgba(0,149,255,0.3)",
            "rgba(255,0,170,0.3)",
            "rgba(255,212,0,0.3)",
            "rgba(106,255,0,0.3)",
            "rgba(0,64,255,0.3)",
            "rgba(237,185,185,0.3)",
            "rgba(185,215,237,0.3)",
            "rgba(231,233,185,0.3)",
            "rgba(220,185,237,0.3)",
            "rgba(185,237,224,0.3)",
            "rgba(143,35,35,0.3)",
            "rgba(35,98,143,0.3)",
            "rgba(143,106,35,0.3)",
            "rgba(107,35,143,0.3)",
          ],
          borderColor: [
            "rgba(255,0,0,0.7)",
            "rgba(255,255,0,0.7)",
            "rgba(0,234,255,0.7)",
            "rgba(170,0,255,0.7)",
            "rgba(255,127,0,0.7)",
            "rgba(191,255,0,0.7)",
            "rgba(0,149,255,0.7)",
            "rgba(255,0,170,0.7)",
            "rgba(255,212,0,0.7)",
            "rgba(106,255,0,0.7)",
            "rgba(0,64,255,0.7)",
            "rgba(237,185,185,0.7)",
            "rgba(185,215,237,0.7)",
            "rgba(231,233,185,0.7)",
            "rgba(220,185,237,0.7)",
            "rgba(185,237,224,0.7)",
            "rgba(143,35,35,0.7)",
            "rgba(35,98,143,0.7)",
            "rgba(143,106,35,0.7)",
            "rgba(107,35,143,0.7)",
          ],
          borderWidth: 3,
          // circular: false,
          hoverBorderWidth: 5,
        },
      ],
    };

    this.setState({ tbGraph: currPolar });
  };

  tbPlot() {
    if (this.state.tbGraph.length != 0) {
      return <PolarArea data={this.state.tbGraph} responsive="true" />;
    } else {
    }
  }

  getNameFromId = (data) => {
    for (let i = 0; i < this.props.nameIdArr.length; i++) {
      if (this.props.nameIdArr[i][0] === data) {
        return this.props.nameIdArr[i][1];
      }
    }
  };

  // Logs the WINNER NAMES for the current week to the console.
logCurrentWeekWinners = async () => {
  // Get current week number and the full winners array structure.
  const currentWeek = await getWeek();
  const winnersArr  = await getWinnersArr();

  // Pull the winning pick IDs for the current week (one per matchup).
  const winIds = winnersArr?.[currentWeek]?.data?.picks || [];

  if (!winIds.length) {
    console.log(`No winners posted yet for week ${currentWeek}.`);
    return;
  }

  // Build a quick lookup: id -> name from your nameIdArr ([id, name] pairs).
  const idToName = new Map(this.props.nameIdArr.map(([id, name]) => [id, name]));

  // Convert winner IDs to human-readable names.
  const winNames = winIds.map(id => idToName.get(id) ?? `(unknown id: ${id})`);

  // Log them all at once.
  console.log(`Week ${currentWeek} winners:`, winNames);
};

// Simplified + commented version of setTable that PRESERVES your
// "append new rows, then remove the old block" cleanup logic at the end.
setTable = async (week) => {
  const table = document.getElementById("picksTable");

  // If this is the very first render, give the DOM a moment.
  if (this.state.prevRows === 0) {
    await sleep(500);
  }

  // Pull winner info once and cache a few easy-to-read flags/structures.
  const winnersArr   = await getWinnersArr();
  const currentWeek  = await getWeek();
  const isPastWeek   = week < currentWeek;
  const winnerData   = winnersArr?.[week]?.data ?? {};
  const winningPickIds   = new Set(winnerData.picks || []);
  const weekTiebreaker   = winnerData.tiebreaker;
  const overallWinnerTid = winnerData.winner_info?.[0];

  // await this.logCurrentWeekWinners();

  // Quick lookups: id -> name, and which names are the "first side" of each matchup.
  const idToName = new Map(this.props.nameIdArr.map(([id, name]) => [id, name]));
  const matchups = this.props.matchups[this.state.selectedWeek - 1] || [];
  const firstTeamNameSet = new Set(matchups.map(m => m?.[0]?.[1]).filter(Boolean));

  // Helper to add a cell with common styling options.
  const addCell = (row, html, opts = {}) => {
    const cell = row.insertCell();
    cell.innerHTML = html ?? "";
    if (opts.bold)      cell.style.fontWeight = "bolder";
    if (opts.center)    cell.style.textAlign  = "center";
    if (opts.fontSize)  cell.style.fontSize   = opts.fontSize;
    if (opts.paddingTop)cell.style.paddingTop = opts.paddingTop;
    if (opts.color)     cell.style.color      = opts.color;
    if (opts.bg)        cell.style.backgroundColor = opts.bg;
    if (opts.border)    cell.style.border     = opts.border;
    if (opts.outline)   cell.style.outline    = opts.outline;
    return cell;
  };

  // Style a pick cell based on correctness, side (red/blue), and lock status.
  const stylePickCell = (cell, { correct, onFirstSide, isLock }) => {
    const strong = onFirstSide ? "rgba(255, 0, 0, 1)"   : "rgba(37, 65, 178, 1)";
    const faded  = onFirstSide ? "rgba(255, 0, 0, 0.3)" : "rgba(37, 65, 178, 0.3)";
    cell.style.backgroundColor = correct ? strong : faded;
    cell.style.border = "solid 2px white";
    cell.style.textAlign = "center";
    if (correct) cell.style.color = "white";
    if (isLock)  cell.style.outline = "solid 4px rgba(224, 221, 30, 1)";
  };

  // -------- HEADER ROW (matchups + tiebreaker) --------
  {
    const header = table.insertRow();
    addCell(header, ""); // blank corner
    for (const m of matchups) {
      const a = m?.[0]?.[1] ?? "";
      const b = m?.[1]?.[1] ?? "";
      addCell(header, `${a} vs. ${b}`, { bold: true });
    }
    const tbLabel = isPastWeek ? `Tiebreaker (${weekTiebreaker ?? ""})` : "Tiebreaker";
    addCell(header, tbLabel, { bold: true });
  }

  // -------- DATA ROWS (one per picker/team) --------
  const weekPicks = this.props.picksByWeek?.[week] || [];
  for (const entry of weekPicks) {
    const row = table.insertRow();

    // Row leader: the picker/team name (with win count if the week is complete).
    const teamName = await this.getNameFromId(entry.Tid);
    let winsText = "";
    if (isPastWeek) {
      let wins = 0;
      for (const pickId of (entry.Ids || [])) {
        if (winningPickIds.has(pickId)) wins++;
      }
      // Lock: +1 if right, -1 if wrong.
      wins += winningPickIds.has(entry.Lock) ? 1 : -1;
      winsText = ` (${wins})`;
    }
    const teamCell = addCell(row, `${teamName}${winsText}`, { bold: true });

    // Highlight the overall weekly winner in gold once results exist.
    if (isPastWeek && overallWinnerTid && idToName.get(overallWinnerTid) === teamName) {
      teamCell.style.backgroundColor = "gold";
    }

    // Pick cells: one per matchup, using the name for the corresponding pick ID in order.
    const pickNames = (entry.Ids || []).map(id => idToName.get(id) ?? "");
    for (let i = 0; i < matchups.length; i++) {
      const pickId   = entry.Ids?.[i];
      const pickName = pickNames?.[i] ?? "";
      const onFirstSide = firstTeamNameSet.has(pickName);
      const correct     = isPastWeek && winningPickIds.has(pickId);
      const isLock      = idToName.get(entry.Lock) === pickName;

      const cell = addCell(row, pickName);
      stylePickCell(cell, { correct, onFirstSide, isLock });
    }

    // Final column: tiebreaker entry for this row.
    addCell(row, entry.TieBreaker, {
      bold: true,
      center: true,
      fontSize: "16px",
      paddingTop: "16px",
    });
  }

  // -------- CLEANUP BLOCK (matches your original logic) --------
  // We append the new header+rows, then remove the previous block from the top.
  // This avoids flicker and keeps the most recent table section.
  if (this.state.prevRows > 0) {
    this.tableCleanup(this.state.prevRows, table);
  }

  // Track how many rows we just rendered (header + N data rows).
  this.setState({ prevRows: (this.props?.picksByWeek?.[week]?.length || 0) + 1 });
};

// Same helper as yours, with comments.
tableCleanup = async (numRows, table) => {
  // Remove the previous block (header + rows) from the top of the table.
  for (let i = 0; i < numRows; i++) {
    if (table.rows.length > 0) table.deleteRow(0);
  }
  // Brief pause to let the DOM paint smoothly before further updates.
  await sleep(500);
  // Whatever you use this flag for — keep behavior identical.
  this.setState({ deletingTables: false });
};


  changeWeek = async (week) => {
    // if (week != this.state.selectedWeek) {
    await this.setState({ selectedWeek: week, deletingTables: true });

    this.createDataSets(week);

    this.createTBPlot(week);
    this.getRankingData(week);

    this.setTable(week);
    // }
  };

  getPieTitle = (rowIndex) => {
    if (
      typeof this.props.matchups[this.state.selectedWeek - 1] !== "undefined" &&
      this.props.matchups[this.state.selectedWeek - 1][0].length > 0 &&
      this.state.ppm[rowIndex]
    ) {
      return (
        <Container>
          <Row>
            <Col>
              <span id="pieT2">
                {
                  this.props.matchups[this.state.selectedWeek - 1][
                    rowIndex
                  ][1][1]
                }
              </span>{" "}
              vs.{" "}
              <span id="pieT1">
                {
                  this.props.matchups[this.state.selectedWeek - 1][
                    rowIndex
                  ][0][1]
                }
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span style={{ color: "blue" }}>
                {this.state.ppm[rowIndex][1]}
              </span>{" "}
              -{" "}
              <span style={{ color: "red" }}>
                {this.state.ppm[rowIndex][0]}
              </span>
            </Col>
          </Row>
        </Container>
      );
    }
  };

  loadButtons() {
    let b = [];
    let w = getWeek();
    let l = 13;

    for (let i = 1; i <= w; i++) {
      if (i == w) {
        b.push(
          <Button
            onClick={() => this.changeWeek(i)}
            id="weekBtnW"
            style={{
              backgroundColor: this.state.selectedWeek == i ? "#03256C" : "",
              color: this.state.selectedWeek == i ? "white" : "",
            }}
            disabled={this.state.deletingTables}
          >
            {i}
          </Button>
        );
      } else {
        b.push(
          <Button
            onClick={() => this.changeWeek(i)}
            id="weekBtn"
            style={{
              backgroundColor: this.state.selectedWeek == i ? "#2541B2" : "",
              color: this.state.selectedWeek == i ? "white" : "",
            }}
            disabled={this.state.deletingTables}
          >
            {i}
          </Button>
        );
      }
    }

    return b;
  }

  getWhoRanked() {
    let r = [];
    for (let i = 0; i < this.state.whoRankedThisWeek.length; i++) {
      r.push(
        <Row>
          <Col style={{ fontSize: "12px" }}>
            {this.state.whoRankedThisWeek[i]}
          </Col>
        </Row>
      );
    }
    return r;
  }

  render() {
    return (
      <div>
        <Container>
          <Row>
            <Col id="horDiv"></Col>
          </Row>
          <Row>
            <Col id="tabTitle">Pick 'Em Results </Col>
          </Row>
          <Row>
            <Col id="horDiv"></Col>
          </Row>
          <Row>
            <ButtonGroup aria-label="Basic example">
              {this.loadButtons()}
            </ButtonGroup>
          </Row>
          <Tabs
            defaultActiveKey="pickem"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="pickem" title="Pick 'Em">
              <Row id="pieTitle">
                <Col>{this.getPieTitle(0)}</Col>

                <Col>{this.getPieTitle(1)}</Col>
              </Row>
              <Row>
                <Col id="pieColL">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[0])}</Col>
                  </Row>
                </Col>
                <Col id="pieColR">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[1])}</Col>
                  </Row>
                </Col>
              </Row>
              <Row id="pieTitle">
                <Col>{this.getPieTitle(2)}</Col>

                <Col>{this.getPieTitle(3)}</Col>
              </Row>
              <Row>
                <Col id="pieColL">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[2])}</Col>
                  </Row>
                </Col>
                <Col id="pieColR">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[3])}</Col>
                  </Row>
                </Col>
              </Row>
              <Row id="pieTitle">
                <Col>{this.getPieTitle(4)}</Col>

                <Col>{this.getPieTitle(5)}</Col>
              </Row>
              <Row>
                {/* <Col lg="3"></Col> */}
                <Col id="pieColL">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[4])}</Col>
                  </Row>
                </Col>
                {/* <Col lg="3"></Col> */}
                <Col id="pieColR">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[5])}</Col>
                  </Row>
                </Col>
              </Row>
              <Row id="pieTitle">
                <Col>{this.getPieTitle(6)}</Col>

                <Col>{this.getPieTitle(7)}</Col>
              </Row>
              <Row>
                <Col id="pieColL">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[6])}</Col>
                  </Row>
                </Col>
                <Col id="pieColR">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[7])}</Col>
                  </Row>
                </Col>
              </Row>
              <Row id="pieTitle">
                <Col>{this.getPieTitle(8)}</Col>

                <Col>{this.getPieTitle(9)}</Col>
              </Row>
              <Row>
                <Col id="pieColL">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[8])}</Col>
                  </Row>
                </Col>
                <Col id="pieColR">
                  <Row>
                    <Col>{this.checkData(this.state.datasets[9])}</Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col id="horDiv"></Col>
              </Row>
              <Row>
                <Col id="SWTBMessage">{tbMessage[this.state.selectedWeek]}</Col>
              </Row>
              <Row>
                <Col
                  style={{
                    padding: "15%",
                    paddingTop: "2%",
                    paddingBottom: "5%",
                  }}
                >
                  {" "}
                  {this.tbPlot()}
                </Col>
              </Row>
              <Row>
                <Col id="horDiv"></Col>
              </Row>
              <Row>
                <Col>
                  <Table responsive id="picksTable"></Table>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="powerrankings" title="Power Rankings">
              <Row>
                <Col sm="0" lg="0"></Col>
                <Col>
                  <Table id="prTable"></Table>
                </Col>
                <Col
                  sm="12"
                  lg="2"
                  style={{
                    borderLeft:
                      window.innerWidth > 1000 ? "1px solid lightgrey" : "",
                  }}
                >
                  <Row
                    style={{
                      marginTop: window.innerWidth > 1000 ? "5px" : "10px",
                      fontSize: "20px",
                    }}
                  >
                    <Col
                      style={{
                        fontWeight:
                          window.innerWidth > 1000 ? "bolder" : "bolder",
                        fontSize: window.innerWidth > 1000 ? "16px" : "20px",
                      }}
                    >
                      Ranked By:
                    </Col>
                  </Row>
                  {this.getWhoRanked()}
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Container>
      </div>
    );
  }
}

<link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
  integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3"
  crossorigin="anonymous"
/>;

export default StatsWeek;
